import * as React from 'react'
import { Button, Col } from 'react-bootstrap'

interface CreateContentProps {
	spinner: boolean
	getAds: (e: any) => void
}

const CreateContentButton: React.FunctionComponent<CreateContentProps> = (props) => {
	return props.spinner ? (
		<Col>
			<i className="fa fa-spinner fa-spin fa-2x text-danger" />
			&nbsp;&nbsp;IMPORTING ARTICLES...
		</Col>
	) : (
		<Button id="generateAdGroup" bsStyle="success" onClick={props.getAds}>
			Create Ads
		</Button>
	)
}

export default CreateContentButton
